<div class="vcol-flex space-around-center">
    <div class="content-center">
        <span pTooltip="Organizations" tooltipPosition="left" class="pi pi-database"></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.organization_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Regions"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.REGION)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.region_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Sites"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.SITE)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.site_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Buildings"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.BUILDING)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.building_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Floors"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.FLOOR)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.floor_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Rooms"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.ROOM)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.room_count ?? '--' }}</div>
        }
    </div>
    <div class="content-center">
        <span
            pTooltip="Racks"
            tooltipPosition="left"
            [ngClass]="LocationUtils.getIconForType(ECPMLocationTypeApiEnum.RACK)"
        ></span>
        @if (showLoading) {
            <div><i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i></div>
        } @else {
            <div>{{ numbers?.racks_count ?? '--' }}</div>
        }
    </div>
</div>
